import { timeRangeFormatter, formatMetricDefValue } from '../../../utilities';

export { dateTimeFormatter, granularityFormatter } from '../../../utilities';

export const timeGranularityFormatter = (start, granularity) => timeRangeFormatter({ start, end: start + granularity });

export const chartDefFormatter = (def, value) => formatMetricDefValue(def, value);
